import { useTranslation } from 'react-i18next';
import { HeaderTitle, HeaderWrapper } from './NOACenterHeader.StyledComponents';

export const NOACenterHeader = () => {
  const { t } = useTranslation('noaCenter');

  return (
    <HeaderWrapper>
      <HeaderTitle>{t('header.title')}</HeaderTitle>
    </HeaderWrapper>
  );
};
